<template>
  <div class="map">
    <img :src="img1" alt="加载中" />
    <img :src="img2" alt="加载中" />
    <img :src="img3" alt="加载中" />
  </div>
</template>

<script setup>
import jpg_1 from "@/assets/img/guide/1.jpg";
import jpg_2 from "@/assets/img/guide/2.png";
import jpg_3 from "@/assets/img/guide/3.png";
import { ref } from "vue";
const img1 = ref(null);
const img2 = ref(null);
const img3 = ref(null);
const imgList = [jpg_1, jpg_2, jpg_3];
// 初始化一个图片对象
const image1 = new Image();
// 赋值url
image1.src = imgList[0];
// 图片加载成功时触发
image1.onload = () => {
  img1.value = image1.src;
  const image2 = new Image();
  image2.src = imgList[1];
  image2.onload = () => {
    img2.value = image2.src;
    const image3 = new Image();
    image3.src = jpg_3;
    image3.onload = () => {
      img3.value = image3.src;
    };
  };
};
</script>

<style scoped lang="scss">
img {
  width: 100%;
}
</style>
